import messages from '../validators/messages';

const Validators = {
  messages,
  urlProtocols: ['http', 'https']
};

export default Validators;
